import { FC } from 'react';

import { UserCardWrapStyled, UserNameStyled } from './UserCard.styled';
import Avatar from 'components/Avatar/Avatar';
import Certification from 'components/Certification/Certification';
import { UserProfileI } from 'declarations/interfaces/user';
import { getUserPlaceholderName } from 'helpers/user';

type UserCardPropsT = {
  userProfile: UserProfileI | null;
  iconOnly?: boolean;
  chirpCertified?: boolean;
};

const UserCard: FC<UserCardPropsT> = ({ userProfile, iconOnly }) => (
  <UserCardWrapStyled className={iconOnly ? 'user-card' : ''}>
    <Avatar
      placeholder={getUserPlaceholderName(userProfile?.firstname, userProfile?.lastname)}
      imageUrl={userProfile?.photoUrl}
    />
    {!iconOnly && (
      <UserNameStyled color="light">
        {userProfile?.firstname} {userProfile?.lastname}
      </UserNameStyled>
    )}
    {userProfile != null && userProfile.chirpCertified && <Certification />}
  </UserCardWrapStyled>
);

export default UserCard;
